import { Form, FormActionsAlign, FormHandlers } from '@doveit/bricks';
import React from 'react';
import { updateAssignedAgentFormValidationSchema } from './UpdateAssignedUserForm.schema';
import { jobApplicationAssigneeUsersOptions } from '../../constants';

export interface UpdateAssignedUserFormModel {
  email?: string,
}

export interface UpdateAssignedUserFormProps extends React.AriaAttributes {
  onSubmit: (values: UpdateAssignedUserFormModel) => void,
  label: string
  isRequired?: boolean,
  initialValues?: Partial<UpdateAssignedUserFormModel>,
  innerRef?: React.MutableRefObject<FormHandlers>
  disabled?: boolean,
  loading?: boolean,
  noSubmit?: boolean
}

export const DEFAULT_INITIAL_VALUES: UpdateAssignedUserFormModel = {
  email: '',
};

const UpdateAssignedUserForm: React.FC<UpdateAssignedUserFormProps> = ({
  initialValues,
  isRequired = false,
  label,
  'aria-label': ariaLabel,
  ...rest
}) => {
  const mergedInitialValues: UpdateAssignedUserFormModel = React.useMemo(() => ({
    ...DEFAULT_INITIAL_VALUES,
    ...initialValues,
  }), [initialValues]);

  return (
    <Form
      initialValues={mergedInitialValues}
      enableReinitialize
      validationSchema={updateAssignedAgentFormValidationSchema(isRequired)}
      {...rest}
    >
      <Form.Item>
        <Form.Select
          name="email"
          label={label}
          aria-label={ariaLabel}
          options={jobApplicationAssigneeUsersOptions}
          required={isRequired}
        />
      </Form.Item>
      {!rest.innerRef && (
        <Form.Actions align={FormActionsAlign.RIGHT}>
          <Form.Submit label="Modifica" />
        </Form.Actions>
      )}
    </Form>
  );
};

export default UpdateAssignedUserForm;
